export const CONSONANT_VOWEL_PAIRS_CH_T = [

    // ㅊ
    {
        id: 1,
        korean: "차",
        english: "cha",

    },
    {
        id: 2,
        korean: "체",
        english: "che",

    },
    {
        id: 3,
        korean: "치",
        english: "chi",

    },
    {
        id: 4,
        korean: "초",
        english: "cho",

    },
    {
        id: 5,
        korean: "츠",
        english: "cheu",

    },
    {
        id: 6,
        korean: "처",
        english: "cheo",

    },
    {
        id: 7,
        korean: "챠",
        english: "chya",

    },
    {
        id: 8,
        korean: "채",
        english: "chae",

    },
    {
        id: 9,
        korean: "쳬",
        english: "chye",

    },
    {
        id: 10,
        korean: "쵸",
        english: "chyo",

    },
    {
        id: 11,
        korean: "쳐",
        english: "chyeo",

    },
    {
        id: 12,
        korean: "츄",
        english: "chyu",  

    },

    {
        id: 13,
        korean: "찬",
        english: "chan", 

    },
    {
        id: 14,
        korean: "칙",
        english: "chak",

        

    },
    {
        id: 15,
        korean: "침",
        english: "chim",
        

    },
    {
        id: 16,
        korean: "찻",
        english: "chat",
        

    },
    {
        id: 17,
        korean: "챃",
        english: "chah",
        

    },
    {
        id: 18,
        korean: "첩",
        english: "cheob",
        

    },
          {
        id: 19,
        korean: "츨",
        english: "cheul",
        

    },
    {
        id: 20,
        korean: "챁",
        english: "chat",
        

    },
    {
        id: 21,
        korean: "챜",
        english: "chaekk",
        

    },
    {
        id: 22,
        korean: "챈",
        english: "chaen",
        

    },
    {
        id: 23,
        korean: "츼",
        english: "chui",
        

    },
    {
        id: 24,
        korean: "춤",
        english: "chum",
        

    },

    {
        id: 25,
        korean: "챷",
        english: "chyat",
        

    },
    {
        id: 26,
        korean: "잧",
        english: "chat",
        

    },
    {
        id: 27,
        korean: "창",
        english: "chang",
        
    },
    {
        id: 28,
        korean: "찰",
        english: "chal",
        
    },
    {
        id: 29,
        korean: "쳘",
        english: "chyeol",
        
    },
    {
        id: 30,
        korean: "쳄",
        english: "chem",
        
    },
    {
        id: 31,
        korean: "첳",
        english: "cheoh",
        
    },
    {
        id: 32,
        korean: "츨",
        english: "cheul",
        
    },
    {
        id: 33,
        korean: "춰",
        english: "chwo",
        
    },
    {
        id: 34,
        korean: "츞",
        english: "chyup",
        
    },
    {
        id: 35,
        korean: "찰",
        english: "chal",
        
    },
        
    {
        id: 36,
        korean: "차추",
        english: "cha-chu",
        
    },    
    {
        id: 37,
        korean: "털츠",
        english: "teo-cheu",
        
    },    
    {
        id: 38,
        korean: "래초",
        english: "rae-cho",
        
    },    
    {
        id: 39,
        korean: "아침",
        english: "a-chim",
        
    },
    {
        id: 40,
        korean: "찿찿",
        english: "chat-chat",
        
    },
    
];

